<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-16">
        <h4 class="mt-3 mb-4">Kosten-Umsatz-Relation (KUR), bzw. das Kosten-Umsatz-Verhältnis (KUV) berechnen</h4>

      </div>
    </div>
    <div class="row">
      <div :class="calcValues.ctr.isResult ? 'col-xl-6 col-lg-7' : 'col-16'">
      
        <div class="row mt-3">
          <div class="col-16">
            
            <label class="form-label">Werbebudget / Kosten</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatBudget" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.budget.suffix"></span>
            </div>
            

            <label class="form-label">Umsatz</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatTurnover" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.turnover.suffix"></span>
            </div>
          
            
          </div>

        </div>
      </div>
      <div class="col-xl-9 offset-xl-1 col-lg-8 mt-3" v-if="calcValues.ctr.isResult">
        <h5>Ergebnis</h5>
        <p>Deine Kunden-Umsatz-Relation (KUR) beträgt: <span class="sb-bold">{{ calcValues.ctr.formatted }} <span v-html="calcValues.ctr.suffix"></span></span>.</p>
        <p><span v-if="calcValues.ctr.text != ''"><span class="sb-bold">{{ calcValues.ctr.text }}</span></span></p>

        <apex-chart width="100%" height="400" :options="getChartOptions" :series="getChartData"></apex-chart>
      </div>
    </div>

 </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "costTurnoverRelation",
  components: {
    'apexChart': VueApexCharts,
  },
  data() {
    return {
      chartoptions: {},
      calcValues: {
        budget: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        turnover: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        ctr: {
          number: 0,
          formatted: '',
          suffix: '%',
          isResult: false,
          text: '',
        },
      },
      colorLine: '#00EEBD'

    }
  },
  mounted() {
    this.chartoptions = {...this.$chartconfig.chartOptionsRadialBar, ...{
      colors: [this.colorLine],
      labels: ['Kosten-Umsatz-Relation'],
    }}
    
  },
  computed: {
    formatBudget: {
      get () {
        return this.getObj('budget').number;
      },
      set (value) {
        return this.setObj('budget', value, 1);
      }
    },
    formatTurnover: {
      get () {
        return this.getObj('turnover').number;
      },
      set (value) {
        return this.setObj('turnover', value, 1);
      }
    },
    getChartData () {
      return [this.$utils.beautifier(this.calcValues.ctr.number, 'en-EN')]
    },
    getChartOptions () {
      return {...this.chartoptions, ...{
        colors: [this.colorLine]
      }}
    }
  },
  methods: {
    
    setResult(name, result) {
      let obj = this.getObj(name);
      obj.isResult = result;
      this.calcValues[name] = obj;
    },
    setObj(name, value, calcResult) {
      let obj = this.getObj(name);
      obj.number = this.$utils.formatStr2Number(value);
      obj.formatted = this.$utils.beautifier(obj.number);
      //console.log(obj.number, obj.formatted);
      this.calcValues[name] = obj;

      if (calcResult) this.calcResult();

      return obj.number;
    },
    setObjContent(name, obj, calcResult) {
      this.calcValues[name] = obj;
      this.setObj(name, obj.number, calcResult);
    },
    getObj(name) {
      return this.calcValues[name];
    },
    calcResult() {

      let budget = this.calcValues.budget;
      let turnover = this.calcValues.turnover;
      let ctr = this.calcValues.ctr;

      //Formel: conversions / clicks * 100

      if (turnover.number == 0) {

        ctr.number = 0;
        ctr.isResult = true;
        ctr.text = 'Au weia! Deine Kampagne läuft gar nicht gut. Du musst dringend Deine Maßnahmen analysieren, denn so wirfst Du nur Geld zum Fenster raus.';
        this.setObjContent('ctr',  ctr, 0);
        this.colorLine = '#FF4D6B'

      } else {

        ctr.number = budget.number / turnover.number * 100;
        ctr.isResult = true;
        this.setObjContent('ctr',  ctr, 0);

        if (ctr.number > 0
            && ctr.number <= 1
        ) {

          ctr.text = 'Deine Kampagne ist perfekt. Besser gehts nicht, bravo!';
          this.setObjContent('ctr',  ctr, 0);
          this.colorLine = '#00EEBD'

        } else if (ctr.number > 1
            && ctr.number < 10
        ) {

          ctr.text = 'Deine Kampagne läuft super. Es geht kaum besser, bravo!';
          this.setObjContent('ctr',  ctr, 0);
          this.colorLine = '#00EEBD'

        } else if (ctr.number >= 10
            && ctr.number <= 20
        ) {

          ctr.text = 'Deine Kampagne läuft gut. Versuche noch ein paar Optimierungen durchzuführen und Deine Kampagnen laufen perfekt.';
          this.setObjContent('ctr',  ctr, 0);
          this.colorLine = '#FCDB8F'

        } else if (ctr.number > 20
            && ctr.number <= 30
        ) {

          ctr.text = 'Deine Kampagne performt noch nicht und ist durchwachsen. Versuche sie zu optimieren.';
          this.setObjContent('ctr',  ctr, 0);
          this.colorLine = '#FCDB8F'

        } else {

          ctr.text = 'Au weia! Deine Kampagne läuft gar nicht gut. Du musst dringend Deine Maßnahmen analysieren, denn so wirfst Du nur Geld zum Fenster raus.';
          this.setObjContent('ctr',  ctr, 0);
          this.colorLine = '#FF4D6B'

        }



      }

    }
  }
}
</script>

<style scoped>

</style>